import { useQuery } from '@tanstack/react-query';
import { useCurrentClient } from 'src/clients/context/CurrentClientProvider';
import { useMemo } from 'react';

type FactFind = {
  id: string;
  clientId: string;
  fileId?: number;
  fileName?: string;
  createdAt: string;
  isGenerated: true;
};

export const useFactFinds = () => {
  const { clientId } = useCurrentClient();

  const { data, isLoading, isError, error, refetch } = useQuery<Omit<FactFind, 'isGenerated'>[]>({
    queryKey: ['clients', clientId, 'fact-finds'],
    enabled: !!clientId,
  });

  const factFinds = useMemo(
    () =>
      data?.map(factFind => ({
        ...factFind,
        isGenerated: true,
      })) || [],
    [data],
  );

  return {
    factFinds,
    isLoading,
    isError,
    error,
    refetch,
  };
};
